<section class="content" id="contentPrint" #contentPrint>
    <header>
        <header-relatorio></header-relatorio>
    </header>
    <main>
        <h3 class="mt-1">Relatório de simulação de previdência líquida</h3>
        <!-- <div class="col-4 px-1 mt-3">
            <span class="title-form">Critérios da simulação</span>
            <p class="content-form-result"></p>
        </div> -->
        <section class="row">
            <div class="col-4 px-1 mt-3">
                <span class="title-form">Valor da Cota Atual</span>
                <p class="content-form-result">{{simulacao.cotaAtual | currency:'BRL'}}</p>
            </div>
            <div class="col-3 px-1 mt-3">
                <span class="title-form">Idade Prevista</span>
                <p class="content-form-result">{{simulacao.filtro.anoAposentar}} anos</p>
            </div>
            <div class="col-3 px-1 mt-3">
                <span class="title-form">Meses Previsto</span>
                <p class="content-form-result">{{simulacao.filtro.mesAposentar}} meses</p>
            </div>
            <div class="col-2 px-1 mt-3">
                <span class="title-form">Aporte</span>
                <p class="content-form-result">{{simulacao.filtro.aporte | currency:'BRL'}}</p>
            </div>
        </section>
        <section class="row mt-2">
            <div class="col-4 px-1 mt-3">
                <span class="title-form">Contribuição Mensal Facultativa</span>
                <p class="content-form-result">{{simulacao.filtro.contribuicaoFacultativa | currency:'BRL'}}</p>
            </div>
            <div class="col-4 px-1 mt-3">
                <span class="title-form">Taxas de Juros Anual</span>
                <p class="content-form-result">{{simulacao.filtro.taxaJuros | percentage}}</p>
            </div>
            <div class="col-4 px-1 mt-3">
                <span class="title-form">Salário Real de Contribuição</span>
                <p class="content-form-result">{{simulacao.salario | currency:'BRL'}}</p>
            </div>
        </section>
        <section class="row mt-2">
            <div class="col-4 px-1 mt-3">
                <span class="title-form">Ultima Contribuição</span>
                <p class="content-form-result">{{simulacao.ultimaContribuicao | currency:'BRL'}}</p>
            </div>
            <div class="col-4 px-1 mt-3">
                <span class="title-form">Saldo de Reserva de Poupança</span>
                <p class="content-form-result">{{simulacao.saldoReserva | currency:'BRL'}}</p>
            </div>
            <div class="col-4 px-1 mt-3">
                <span class="title-form">Data Base da Cota</span>
                <p class="content-form-result">{{simulacao.cotaAtualDate | date:'dd/MM/yyyy'}}</p>
            </div>
        </section>
        <section class="content-aviso">
            <h4>Aviso</h4>
            <p class="aviso-mensagem">
                A impressão dessa simulação de benefício contempla os dados atuais e também os projetados,
                de acordo com a idade escolhida. A cada mês ocorrerão alteração de valores em decorrência da entrada
                de contribuição e retorno dos investimentos.
            </p>
        </section>
        <table class="col-12">
            <thead>
                <tr>
                    <th class="col-3 px-0">Valor</th>
                    <th class="col-5 px-0">Descrição</th>
                    <th class="col-2 px-0">Proventos</th>
                    <th class="col-2 px-0">Descontos</th>
                </tr>
            </thead>
            <tbody>
                <tr class="page-break content-resultado" *ngFor="let provento of simulacao.proventos">
                    <td class="col-3 px-0">{{ provento.verba }}</td>
                    <td class="col-5 px-0">{{ provento.descricao }}</td>
                    <td class="col-2 px-0">{{ provento.valor | currency:'BRL' }}</td>
                    <td class="text-center col-2 px-0"> - </td>
                </tr>
                <tr class="page-break content-resultado" *ngFor="let provento of simulacao.descontos">
                    <td class="col-3 px-0">{{ provento.verba }}</td>
                    <td class="col-5 px-0">{{ provento.descricao }}</td>
                    <td class="col-2 px-0 text-center"> - </td>
                    <td class="col-2 px-0">{{ provento.valor | currency:'BRL' }}</td>
                </tr>
            </tbody>
        </table>
        <section class="col-12 content-resultado-total">
            <div class="col-3">
                <span>Tabela Regressiva:</span>
            </div>
            <div class="col-3">
                <span>Total de Proventos</span>
                <p>{{simulacao.totalProventos | currency:'BRL'}}</p>
            </div>
            <div class="col-3">
                <span>Total de Descontos</span>
                <p>{{simulacao.totalDescontosRegressivo | currency:'BRL'}}</p>
            </div>
            <div class="col-3">
                <span>Total Líquido</span>
                <p>{{simulacao.totalLiquidoRegressivo | currency:'BRL'}}</p>
            </div>
        </section>
        <section class="col-12 content-resultado-total">
            <div class="col-3">
                <span>Tabela Progressiva</span>
            </div>
            <div class="col-3">
                <span>Total de Proventos</span>
                <p>{{simulacao.totalProventos | currency:'BRL'}}</p>
            </div>
            <div class="col-3">
                <span>Total de Descontos</span>
                <p>{{simulacao.totalDescontosProgressivo | currency:'BRL'}}</p>
            </div>
            <div class="col-3">
                <span>Total Líquido</span>
                <p>{{simulacao.totalLiquidoProgressivo | currency:'BRL'}}</p>
            </div>
        </section>
        <section class="content-aviso">
            Beneficio bruto na data atual: {{simulacao.beneficioHoje | currency: 'BRL'}}
        </section>
        <section class="content-footer">
            <article class="footer__page__informacoes mt-6 mb-3">
                <p class="footer__page__informacoes__title__informacoes footer__title">INFORMAÇÕES</p>
                <br>
                <p class="ml-1 content__informacoes"
                    *ngIf="!simulation || simulation.totalProventos >= simulation.socialSecurityUnit * 2">
                    Caso os valores apresentados ainda não estejam dentro da sua expectativa, existem formas de melhorar
                    o
                    seu benefício, como contribuir por mais tempo, aumentar sua contribuição extra mensal ou realizar
                    aportes.
                </p>
                <p class="ml-1 content__informacoes"
                    *ngIf="simulation && simulation.totalProventos < simulation.socialSecurityUnit * 2">
                    Como o valor mínimo do seu benefício não pode ser abaixo de {{simulation.socialSecurityUnit * 2 |
                    currency:'BRL' }} (valor equivalente a 2 unidades previdenciárias), suas alternativas são contribuir
                    por mais tempo,
                    aumentar sua contribuição extra mensal ou realizar um aporte para {{simulation.aporteFaltanteHoje |
                    currency:'BRL'}}. Caso não seja possível, será necessário um aporte, na idade de aposentadoria, no
                    valor
                    de {{simulation.aporteFaltanteProjetado | currency:'BRL'}}.
                </p>
                <br>
                <p class="footer__page__informacoes__title__notas footer__title mt-1">NOTAS</p>
                <br>
                <div>
                    <ul class="footer__content__notas">
                        <li>O resultado dessa simulação é uma projeção que não se constitui, de modo algum, em garantia,
                            proposta ou obrigação por parte da Fundação Copel.</li>
                        <li>O valor do saldo projetado foi estimado com base em uma hipótese de rentabilidade que você
                            simulou na fase de capitalização, porém, a rentabilidade real dependerá da performance das
                            aplicações.</li>
                        <li>Para a conversão em renda foi utilizada a hipótese de taxa de juros vigente.</li>
                        <li>O valor do aporte apresentado, quando for o caso, representa apenas uma das condições para a
                            elegibilidade para o benefício.
                            Deverão ser verificadas as demais condições de elegibilidade como idade e tempo de filiação.
                        </li>
                        <li>Os valores simulados podem ter variação de acordo com o motivo do desligamento. Havendo
                            dúvidas favor entrar em contato com nossa Central de Atendimento</li>
                    </ul>
                </div>
            </article>
        </section>
    </main>
    <footer>
        <footer-relatorio></footer-relatorio>
    </footer>
</section>